<template>
  <div class="cstep">
    <div class="cstep__head">
      <h2 class="cstep__title">Características</h2>
      <p class="cstep__sub">{{ $t("required_fields_caption") }}</p>
    </div>

    <v-form lazy-validation v-model="valid" ref="description" class="cstep__form">
      <div class="cstep__card">
        <div class="cstep__label">Características principales</div>
        <div class="cstep__grid">
          <v-text-field
            v-for="(field, idx) in requiredCharacteristics"
            :key="field.name + idx"
            outlined
            dense
            type="number"
            :label="field.name + ' *'"
            :suffix="suffixes[field.name] || ''"
            :rules="[v => !!v || $t('required_fields_hint')]"
            v-model="field.value"
          ></v-text-field>
        </div>
      </div>

      <div class="cstep__card">
        <div class="cstep__label">
          {{ $t("property.create.description.fields.additional_features.title") }}
        </div>
        <div class="cstep__grid">
          <v-text-field
            v-for="field in optionalCharacteristics"
            :key="field.name"
            outlined
            dense
            :label="field.name"
            :suffix="suffixes[field.name] || ''"
            v-model="field.value"
          ></v-text-field>
        </div>
      </div>
    </v-form>

    <div class="cstep__card">
      <div class="cstep__label">Plano de la propiedad</div>
      <label class="cstep__drop">
        <hero-icon :icon="PhotoIcon" :size="20" />
        <span>{{
          property.blueprint && property.blueprint.name
            ? property.blueprint.name
            : 'Subir plano'
        }}</span>
        <input type="file" accept="image/*" @change="onBlueprint" />
      </label>
    </div>

    <div v-if="isRent" class="cstep__card">
      <div class="cstep__label">Condiciones de alquiler</div>
      <div class="cstep__grid">
        <v-select
          outlined
          dense
          clearable
          label="Admite mascotas"
          :items="petsOptions"
          v-model="property.features.pets"
        ></v-select>
        <v-select
          outlined
          dense
          clearable
          label="Cantidad máxima de ocupantes"
          :items="occupantsOptions"
          v-model="property.features.max_occupants"
        ></v-select>
      </div>
    </div>

    <div
      class="cstep__card"
      v-for="(feature, i) in property.features.additional_features"
      :key="i"
    >
      <div class="cstep__label">{{ feature.name }}</div>
      <div class="cstep__checks">
        <v-checkbox
          v-for="(label, j) in features[feature.name]"
          :key="j"
          v-model="feature.values"
          :label="label"
          :value="label"
          color="primary"
          hide-details
          dense
          class="cstep__check"
        ></v-checkbox>
      </div>
    </div>

    <div class="cstep__footer">
      <v-btn text color="primary" class="rounded-lg" @click="$router.go(-1)">
        {{ $t("action.close_and_continue_later") }}
      </v-btn>
      <v-btn color="accent" depressed class="rounded-lg" @click="nextStep">
        {{ $t("action.next") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { EditProperty } from "@/graphql/mutations/properties";
import HeroIcon from "@/components/shared/HeroIcon";
import PhotoIcon from "heroicons/24/outline/photo.svg";

export default {
  data() {
    return {
      PhotoIcon,
      valid: true,
      petsOptions: [
        { text: "Sí", value: "yes" },
        { text: "No", value: "no" },
        { text: "Consultar", value: "ask" }
      ],
      occupantsOptions: [1, 2, 3, 4, 5],
      features: {
        Servicios: [
          this.$t(
            "property.create.description.fields.services.drinking_water_network"
          ),
          this.$t("property.create.description.fields.services.water_drilling"),
          this.$t("property.create.description.fields.services.gas_network"),
          this.$t("property.create.description.fields.services.sewer"),
          this.$t(
            "property.create.description.fields.services.electric_netowrk"
          ),
          this.$t("property.create.description.fields.services.street_lighting")
        ],
        Acceso: [
          this.$t("property.create.description.fields.access.dirt"),
          this.$t("property.create.description.fields.access.enhanced_dirt"),
          this.$t("property.create.description.fields.access.gravel"),
          this.$t("property.create.description.fields.access.pavement")
        ],
        "Comodidades y amenities": [
          this.$t(
            "property.create.description.fields.comforts_and_amenities.internet"
          ),
          this.$t(
            "property.create.description.fields.comforts_and_amenities.air_conditioning"
          ),
          this.$t(
            "property.create.description.fields.comforts_and_amenities.childrens_play_area"
          ),
          this.$t(
            "property.create.description.fields.comforts_and_amenities.elevator"
          ),
          this.$t(
            "property.create.description.fields.comforts_and_amenities.business_center"
          ),
          this.$t(
            "property.create.description.fields.comforts_and_amenities.heating"
          ),
          this.$t(
            "property.create.description.fields.comforts_and_amenities.tennis_court"
          ),
          this.$t(
            "property.create.description.fields.comforts_and_amenities.fireplace"
          ),
          this.$t(
            "property.create.description.fields.comforts_and_amenities.tank"
          ),
          this.$t(
            "property.create.description.fields.comforts_and_amenities.visitor_parking"
          ),
          this.$t(
            "property.create.description.fields.comforts_and_amenities.gym"
          ),
          this.$t(
            "property.create.description.fields.comforts_and_amenities.jacuzzi"
          ),
          this.$t(
            "property.create.description.fields.comforts_and_amenities.laundry"
          ),
          this.$t(
            "property.create.description.fields.comforts_and_amenities.pets"
          ),
          this.$t(
            "property.create.description.fields.comforts_and_amenities.pool"
          ),
          this.$t(
            "property.create.description.fields.comforts_and_amenities.reception"
          ),
          this.$t(
            "property.create.description.fields.comforts_and_amenities.party_room"
          ),
          this.$t(
            "property.create.description.fields.comforts_and_amenities.multiple_uses_room"
          ),
          this.$t(
            "property.create.description.fields.comforts_and_amenities.security"
          )
        ],
        "Características adicionales": [
          this.$t(
            "property.create.description.fields.additional_characteristics.water"
          ),
          this.$t(
            "property.create.description.fields.additional_characteristics.furnished"
          ),
          this.$t(
            "property.create.description.fields.additional_characteristics.boiler"
          ),
          this.$t(
            "property.create.description.fields.additional_characteristics.gas"
          ),
          this.$t(
            "property.create.description.fields.additional_characteristics.forested"
          ),
          this.$t(
            "property.create.description.fields.additional_characteristics.sprinkler_irrigation"
          ),
          this.$t(
            "property.create.description.fields.additional_characteristics.masonry_perimeter_enclosure"
          ),
          this.$t(
            "property.create.description.fields.additional_characteristics.green_perimeter_enclosure"
          )
        ],
        Ambientes: [
          this.$t("property.create.description.fields.environments.balcony"),
          this.$t("property.create.description.fields.environments.grill"),
          this.$t("property.create.description.fields.environments.kitchen"),
          this.$t("property.create.description.fields.environments.courtyard"),
          this.$t(
            "property.create.description.fields.environments.dinning_room"
          ),
          this.$t("property.create.description.fields.environments.placards"),
          this.$t(
            "property.create.description.fields.environments.service_unit"
          ),
          this.$t(
            "property.create.description.fields.environments.breakfast_nook"
          ),
          this.$t(
            "property.create.description.fields.environments.roof_garden"
          ),
          this.$t(
            "property.create.description.fields.environments.suite_bedroom"
          ),
          this.$t("property.create.description.fields.environments.terrace"),
          this.$t("property.create.description.fields.environments.studio"),
          this.$t("property.create.description.fields.environments.toilette"),
          this.$t("property.create.description.fields.environments.garden"),
          this.$t(
            "property.create.description.fields.environments.dressing_room"
          ),
          this.$t(
            "property.create.description.fields.environments.laundry_room"
          ),
          this.$t("property.create.description.fields.environments.living_room")
        ]
      },
      suffixes: {
        [this.$t(
          "property.create.description.fields.additional_features.antiquity"
        )]: this.$t(
          "property.create.description.fields.additional_features.antiquity_suffix"
        ),
        [this.$t(
          "property.create.description.fields.features.covered_surface"
        )]: this.$t(
          "property.create.description.fields.features.covered_surface_suffix"
        ),
        [this.$t(
          "property.create.description.fields.features.mid_covered_surface"
        )]: this.$t(
          "property.create.description.fields.features.total_surface_suffix"
        ),
        [this.$t(
          "property.create.description.fields.features.total_surface"
        )]: this.$t(
          "property.create.description.fields.features.total_surface_suffix"
        )
      },
      property: {
        blueprint: null,
        description: null,
        characteristicsAttributes: [
          {
            name: this.$t(
              "property.create.description.fields.features.covered_surface"
            ),
            value: "0"
          },
          {
            name: this.$t(
              "property.create.description.fields.features.total_surface"
            ),
            value: "0"
          },
          {
            name: this.$t(
              "property.create.description.fields.features.mid_covered_surface"
            ),
            value: "0"
          },
          {
            name: this.$t(
              "property.create.description.fields.environments.title"
            ),
            value: "0"
          },
          {
            name: this.$t(
              "property.create.description.fields.features.bedrooms"
            ),
            value: "0"
          },
          {
            name: this.$t(
              "property.create.description.fields.features.bathrooms"
            ),
            value: "0"
          },
          {
            name: this.$t("property.create.description.fields.features.garage"),
            value: "0"
          },
          {
            name: this.$t(
              "property.create.description.fields.additional_features.floor_number"
            ),
            value: "0"
          },
          {
            name: this.$t(
              "property.create.description.fields.additional_features.apartments_by_floor"
            ),
            value: "0"
          },
          {
            name: this.$t(
              "property.create.description.fields.additional_features.floors_quantity"
            ),
            value: "0"
          },
          {
            name: this.$t(
              "property.create.description.fields.additional_features.antiquity"
            ),
            value: "0"
          },
          {
            name: this.$t(
              "property.create.description.fields.features.terrain_width"
            ),
            value: "0"
          },
          {
            name: this.$t(
              "property.create.description.fields.features.terrain_depth"
            ),
            value: "0"
          },
          {
            name: this.$t("property.create.description.fields.features.facing"),
            value: ""
          },
          {
            name: this.$t(
              "property.create.description.fields.features.location"
            ),
            value: ""
          }
        ],
        features: {
          operation_type: {
            rent: false,
            sell: false
          },
          // Rental conditions — only shown/used for rent listings
          pets: null,
          max_occupants: null,
          additional_features: [
            {
              name: this.$t(
                "property.create.description.fields.services.title"
              ),
              values: []
            },
            {
              name: this.$t("property.create.description.fields.access.title"),
              values: []
            },
            {
              name: this.$t(
                "property.create.description.fields.comforts_and_amenities.title"
              ),
              values: []
            },
            {
              name: this.$t(
                "property.create.description.fields.additional_characteristics.title"
              ),
              values: []
            },
            {
              name: this.$t(
                "property.create.description.fields.environments.title"
              ),
              values: []
            }
          ]
        }
      }
    };
  },

  computed: {
    isRent() {
      return !!(this.property.features.operation_type || {}).rent;
    },

    requiredCharacteristics() {
      var filtered = this.property.characteristicsAttributes.filter(v =>
        [
          this.$t("property.create.description.fields.features.total_surface"),
          this.$t(
            "property.create.description.fields.features.covered_surface"
          ),
          this.$t("property.create.description.fields.environments.title"),
          this.$t("property.create.description.fields.features.bedrooms"),
          this.$t("property.create.description.fields.features.bathrooms"),
          this.$t("property.create.description.fields.features.garage")
        ].includes(v.name)
      );
      return filtered;
    },

    optionalCharacteristics() {
      var filtered = this.property.characteristicsAttributes.filter(
        v =>
          ![
            this.$t(
              "property.create.description.fields.features.total_surface"
            ),
            this.$t(
              "property.create.description.fields.features.covered_surface"
            ),
            this.$t("property.create.description.fields.environments.title"),
            this.$t("property.create.description.fields.features.bedrooms"),
            this.$t("property.create.description.fields.features.bathrooms"),
            this.$t("property.create.description.fields.features.garage")
          ].includes(v.name)
      );
      return filtered;
    }
  },

  props: {
    fetchedProperty: {
      type: Object,
      required: true
    }
  },

  created() {
    // Object.assign(this.property.features, this.fetchedProperty.features)

    Object.keys(this.property.features).forEach(key => {
      if (this.fetchedProperty.features[key]) {
        if (Array.isArray(this.property.features[key])) {
          this.property.features[key].forEach((feature, i) => {
            const fetched_feature = this.fetchedProperty.features[key].find(
              ff => ff.name == feature.name
            );

            if (fetched_feature) {
              this.property.features[key][i] = fetched_feature;
            }
          });
        } else if (
          this.property.features[key] !== null &&
          typeof this.property.features[key] === "object"
        ) {
          Object.assign(
            this.property.features[key],
            this.fetchedProperty.features[key]
          );
        } else {
          this.property.features[key] = this.fetchedProperty.features[key];
        }
      }
    });

    this.property.description = this.fetchedProperty.description;

    if (this.fetchedProperty.characteristics.length) {
      this.property.characteristicsAttributes.forEach((char, i) => {
        const fetched_char = this.fetchedProperty.characteristics.find(
          c => c.name == char.name
        );

        if (fetched_char) {
          this.property.characteristicsAttributes[i] = fetched_char;
        }
      });

      // this.property.characteristicsAttributes = this.fetchedProperty.characteristics
      this.property.characteristicsAttributes.forEach(char => {
        delete char.__typename;
      });
    }
  },

  watch: {
    valid(newVal) {
      if (!newVal) {
        this.$vuetify.goTo(0);
      }
    }
  },

  methods: {
    onBlueprint(e) {
      this.property.blueprint = (e.target.files && e.target.files[0]) || null;
    },

    nextStep() {
      this.editProperty();
    },

    editProperty() {
      if (this.valid) this.$refs.description.validate();

      if (this.valid) {
        this.$apollo
          .mutate({
            mutation: EditProperty,
            variables: {
              input: {
                attributes: this.property,
                propertyId: this.fetchedProperty.id
              }
            }
          })
          .then(res => {
            this.$emit("continue", res.data.editProperty.property);
          });
      }
    }
  },

  components: {
    HeroIcon
  }
};
</script>

<style scoped>
.cstep__head { margin-bottom: 16px; }
.cstep__title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1814;
  margin: 0;
  line-height: 1.2;
}
.cstep__sub { font-size: 12.5px; color: #a39a8c; margin: 4px 0 0; }

.cstep__card {
  background: #fff;
  border: 1px solid #ece7de;
  border-radius: 14px;
  padding: 20px 22px;
  margin-bottom: 12px;
}
.cstep__label {
  font-size: 10px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #a39a8c;
  font-weight: 600;
  margin-bottom: 14px;
}

.cstep__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 4px 16px;
}

.cstep__checks {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 0 14px;
}
.cstep__check {
  margin-top: 0 !important;
  padding-top: 4px !important;
}
.cstep__check >>> label { font-size: 13.5px; color: #56504a; }

/* blueprint upload */
.cstep__drop {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border: 1.5px dashed #dcd4c6;
  border-radius: 10px;
  background: #faf8f4;
  cursor: pointer;
  font-size: 13.5px;
  font-weight: 600;
  color: #1a1814;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.cstep__drop:hover { border-color: #b52118; background: #f5f1ea; }
.cstep__drop .hero-icon { color: #a39a8c; }
.cstep__drop input { display: none; }

.cstep__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 18px;
}

/* warm outlined fieldsets */
.cstep >>> .v-text-field--outlined fieldset { border-radius: 10px; }
.cstep >>> .v-text-field--outlined.v-input--is-focused fieldset { border-color: #b52118; }
</style>
